import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import CardFace from '../Card/CardFace';
import { selectHand, selectPlayer } from '../ActiveGame/selectors';
import { selectPicksSource } from '../Picks/selectors';
import { TRAINER } from '../Picks/constants';
import { useDragging } from '../Drag/dropTargets';

/**
 * The Trainer a player is playing, face up beside their active Pokémon while they choose what it does (Energy
 * Retrieval's cards, Gust of Wind's Pokémon), as it would lie on the table. Once played it flies on to the discard
 * pile from here (cardMoves goes by way of this spot). An empty card-sized box otherwise, so the spot can be found.
 */
const TrainerInPlay = ({ userId }) => {
  const player = useSelector(selectPlayer);
  const source = useSelector(selectPicksSource);
  const hand = useSelector((state) => selectHand(state, { userId }));
  const mine = player.getIn(['user', 'id']) === userId;
  // Dragged, the card is under your finger: it isn't on the board until it's let go. One dragged onto a Pokémon
  // (Potion) goes on that Pokémon, not here, for the rest of its play.
  const dragging = useDragging();
  const droppedOnPokemon = useRef(false);
  if (dragging && dragging.kind === TRAINER && !dragging.dropAnywhere) {
    droppedOnPokemon.current = true;
  } else if (!source) {
    droppedOnPokemon.current = false;
  }
  const picking = mine && source && source.get('kind') === TRAINER && !dragging && !droppedOnPokemon.current;
  const inHand = picking && hand ? hand.get('cards').find(card => card.get('order') === source.get('handPosition')) : null;
  // Once played it has left the hand, but it lies here until the play is over, to fly on to the discard pile.
  const last = useRef(null);
  if (inHand) {
    last.current = inHand;
  } else if (!picking) {
    last.current = null;
  }
  const playing = inHand || last.current;

  return (
    <div data-showing={playing ? playing.get('id') : undefined} style={{ width: 'var(--card-w)', aspectRatio: '600 / 825' }}>
      {playing && <CardFace card={playing} />}
    </div>
  );
};

TrainerInPlay.propTypes = {
  userId: PropTypes.number.isRequired,
};

export default TrainerInPlay;
